import { ParametricSelector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'
import { ProcessingCost } from '../types'

export const processingCostSelector: ParametricSelector<ReduxState, number, ProcessingCost | void> = (state, processingCostId) =>
  state.processingCosts.processingCosts[processingCostId]

export default processingCostSelector
